import UriUtils from 'chairisher/util/uri';

import { isBot, isImpersonated, isStaff } from 'chairisher/context/auth';

const ChairishContext = window.chairisher.context;

/**
 * @returns {Object} The various utm_* params stored in the Chairish context
 */
function getUtmParams() {
    return ChairishContext.utm || {};
}

/**
 * @returns {string|undefined} The utm_campaign param for the current page, if any
 */
export function getUtmCampaign() {
    return getUtmParams().utm_campaign;
}

/**
 * @returns {string|undefined} The utm_medium param for the current page, if any
 */
export function getUtmMedium() {
    return getUtmParams().utm_medium;
}

/**
 * @returns {string|undefined} The utm_source param for the current page, if any
 */
export function getUtmSource() {
    return getUtmParams().utm_source;
}

/**
 * Caches off the various utm_* params into the Chairish context
 */
export function storeUtmParams() {
    ChairishContext.utm = {
        utm_campaign: UriUtils.extractParamFromUri(document.location.search, 'utm_campaign'),
        utm_medium: UriUtils.extractParamFromUri(document.location.search, 'utm_medium'),
        utm_source: UriUtils.extractParamFromUri(document.location.search, 'utm_source'),
    };
}

/**
 * @returns {string} The API key to use with Amplitude
 */
export function getAmplitudeApiKey() {
    return ChairishContext.AMPLITUDE_API_KEY;
}

/**
 * @returns {string} The client-side deployment key to use with Amplitude
 */
export function getAmplitudeDeploymentKeyClient() {
    return ChairishContext.AMPLITUDE_DEPLOYMENT_KEY_CLIENT;
}

/**
 * @returns {string} The device ID from the Amplitude cookie that was stored in localStorage
 */
export function getAmplitudeDeviceIdFromLocalStorage() {
    return ChairishContext.AMPLITUDE_DEVICE_ID_FROM_LOCAL_STORAGE;
}

/**
 * @returns {string} The device ID from the Amplitude cookie that was sent from the server
 */
export function getAmplitudeDeviceIdFromServer() {
    return ChairishContext.AMPLITUDE_DEVICE_ID_FROM_SERVER;
}

/**
 * @returns {Boolean} True if Amplitude analytics should be allowed for the current user
 */
export function shouldAllowAmplitudeAnalytics() {
    return !isBot() && !isImpersonated() && (!isStaff() || ChairishContext.SHOULD_ALLOW_AMPLITUDE_STAFF);
}
